/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { request } from '@mairistem/tools';

import { baseUrlApi } from '@/routes';
import { conventionVersEtcv } from '@/utils';

const useUpdateConvention = () => {
  const [loading, setLoading] = React.useState(false);

  // Met à jour une convention à partir de son identifiant
  const updateConvention = React.useCallback(
    (identifiant: number | string, payload: any) => {
      setLoading(true);

      return request
        .put(
          `${baseUrlApi}/conventions/${identifiant}`,
          conventionVersEtcv(payload),
        )
        .finally(() => {
          setLoading(false);
        });
    },
    [],
  );

  return { updateConvention, loading };
};

export default useUpdateConvention;
